



































































































import { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum';
import { EngagementTypeComponentEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-type-component.enum';

import { mapActions, mapGetters } from 'vuex';

import {
  Filters,
  FirstLoginModal,
  LoadingMask,
  NavigationMenu,
  TransitionHeight,
  UiIconButton,
  UiModal,
  UiSnackbarContainer,
  YearlySummaryModal
} from '../components';

import { DeviceEnum, DomainEnum, FeatureIdEnum, KeyboardCodeEnum, PermissionLevelEnum } from '../enums';

import {
  GUARDS_EXECUTOR,
  LoadConfigGuard,
  LoginGuard,
  SetContextWithUrlGuard,
  SetFiltersVisibilityGuard,
  SetFullscreenFromUrlGuard
} from '../guards';

import { FeatureNode, TaggingActionPayload } from '../models';

import { APP_CONSTS } from '../store/app/app.consts';
import { CONFIG_CONSTS } from '../store/config/config.consts';
import { CONTEXT_CONSTS } from '../store/context/context.consts';
import { TAGGING_CONSTS } from '../store/tagging/tagging.consts';
import { YEARLY_SUMMARY_CONSTS } from '../store/yearly-summary/yearly-summary.consts';

import { FeaturesTreeUtils, TaggingUtils } from '../utils';

import InstanceSelector from './instance-selector.view.vue';

export default {
  name: 'home',
  beforeRouteEnter: GUARDS_EXECUTOR([
    LoginGuard.execute,
    LoadConfigGuard.execute,
    SetContextWithUrlGuard.execute,
    SetFullscreenFromUrlGuard.execute,
    SetFiltersVisibilityGuard.execute
  ]),
  beforeRouteUpdate: GUARDS_EXECUTOR([
    LoginGuard.execute,
    SetContextWithUrlGuard.execute,
    SetFullscreenFromUrlGuard.execute,
    SetFiltersVisibilityGuard.execute
  ]),
  components: {
    InstanceSelector,
    UiIconButton,
    TransitionHeight,
    Filters,
    UiSnackbarContainer,
    LoadingMask,
    NavigationMenu,
    UiModal,
    FirstLoginModal,
    YearlySummaryModal
  },
  mounted: function () {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  beforeDestroy: function () {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  computed: {
    ...mapGetters(APP_CONSTS.moduleName, {
      fullscreen: APP_CONSTS.getters.fullscreen,
      menuCollapsed: APP_CONSTS.getters.menuCollapsed,
      filtersHidden: APP_CONSTS.getters.filtersHidden,
      featuresTree: APP_CONSTS.getters.featuresTree
    }),
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      currentInstance: CONFIG_CONSTS.getters.currentInstance
    }),
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context,
      enabledFilters: CONTEXT_CONSTS.getters.enabledFilters,
      appliedFiltersCount: CONTEXT_CONSTS.getters.appliedFiltersCount
    }),
    ...mapGetters(YEARLY_SUMMARY_CONSTS.moduleName, {
      yearlySummaryAlreadyViewed: YEARLY_SUMMARY_CONSTS.getters.yearlySummaryAlreadyViewed
    }),
    title: function () {
      const appMessages = this.$epb.messages.app;
      const routeMeta = this.$route.meta;
      return (appMessages.routes[routeMeta.titleI18nKey] || appMessages.features[routeMeta.featureId] || appMessages.routes.home);
    },
    filters: function () {
      return Object.values(this.enabledFilters);
    },
    areFiltersVisible: function (): boolean {
      return (!this.filtersHidden && !!this.filters.length);
    },
    showYearly: function (): boolean {
      const todayTime = new Date().getTime();
      const { start, end } = this.yearlySummary.date;
      const isYearlyTime = (todayTime > start.getTime() && todayTime < end.getTime());
      return (isYearlyTime && this.hasFeaturePermission(FeatureIdEnum.ANALYTICS, this.featuresTree[DomainEnum.SEARCH]));
    },
    removeContentPadding: function () {
      return this.$route.meta && this.$route.meta.style ? this.$route.meta.style.removeContentPadding : false;
    },
    backgroundContrast: function (): boolean {
      return this.$route.meta && this.$route.meta.style ? this.$route.meta.style.backgroundContrast : false;
    },
    isSmallDevice: function (): boolean {
      return this.$epb.device <= DeviceEnum.SMALL_TABLET;
    },
    showYearlySummaryModal: function (): boolean {
      return (this.showYearly && (!this.yearlySummaryAlreadyViewed || this.yearlySummary.opened));
    }
  },
  data: function () {
    return {
      menuOpened: false,
      filtersOpened: false,
      loading: {
        visible: false,
        message: undefined
      },
      error: {
        title: undefined,
        message: undefined
      },
      yearlySummary: {
        date: {
          start: new Date(2022, 11, 15),
          end: new Date(2023, 0, 15)
        },
        opened: false,
        hovered: false,
        icon: require(`../assets/media/image/yearly-summary/candy_icon.svg`)
      },
      yearlyIcon: require(`../assets/media/image/yearly-summary/candy_icon.svg`),
      messages: this.$epb.messages.app,
      DeviceEnum,
      FeatureIdEnum
    };
  },
  methods: {
    ...mapActions(CONTEXT_CONSTS.moduleName, {
      setFiltersSelectedValues: CONTEXT_CONSTS.actions.setFiltersSelectedValues
    }),
    ...mapActions(TAGGING_CONSTS.moduleName, {
      tagAction: TAGGING_CONSTS.actions.tagAction
    }),
    ...mapActions(YEARLY_SUMMARY_CONSTS.moduleName, {
      setYearlySummaryAlreadyViewed: YEARLY_SUMMARY_CONSTS.actions.setYearlySummaryAlreadyViewed
    }),
    toggleMenu: function () {
      this.menuOpened = !this.menuOpened;
    },
    toggleFilters: function () {
      this.filtersOpened = !this.filtersOpened;
    },
    onYearlyAccessClick: function (): void {
      this.yearlySummary.opened = true;
      this.tagYearlySummaryAction(EngagementTypeComponentEnum.ONBOARD_ACCESS);
    },
    setYearlySummaryViewedOnStore: function (): void {
      this.yearlySummary.opened = false;
      this.setYearlySummaryAlreadyViewed(true);
    },
    tagYearlySummaryAction: function (component: EngagementTypeComponentEnum): void {
      const taggingPayload: TaggingActionPayload = {
        ...TaggingUtils.getTaggingPayload(FeatureIdEnum.YEARLY_SUMMARY, DomainEnum.GLOBAL),
        type: EngagementActionsTypeEnum.CLICK,
        component
      };
      this.tagAction(taggingPayload);
    },
    closeMenuOrFilters: function () {
      if (this.menuOpened) {
        this.toggleMenu();
      } else if (this.filtersOpened) {
        this.toggleFilters();
      }
    },
    onContextChanged: function () {
      this.$router.replace(SetContextWithUrlGuard.updateRouteWithContext(this.$route, this.context));
    },
    showSnackbar: function (message: string) {
      this.$refs.snackbarContainer.createSnackbar({
        message: message
      });
    },
    showError: function (error: { title: string; message: string; }) {
      this.error.title = error.title;
      this.error.message = error.message;
      this.$refs.errorModal.open();
    },
    resetScroll: function (): void {
      this.$refs.content.scrollTop = 0;
    },
    updateLoading: function (loading: { visible: boolean; message: string; }): void {
      this.loading = loading;
    },
    escapeKeyListener: function (keyboardEvent: KeyboardEvent) {
      if (keyboardEvent.key === KeyboardCodeEnum.ESC && (this.menuOpened || this.filtersOpened)) {
        this.menuOpened = false;
        this.filtersOpened = false;
      }
    },
    hasFeaturePermission: function (featureId: FeatureIdEnum, featureNodes: FeatureNode[]) {
      const node = FeaturesTreeUtils.getFeatureNode(featureId, featureNodes);
      return (!!node && node.permissionLevel !== PermissionLevelEnum.NONE);
    }
  }
};

